/** Created by azhou on 2019/3/23.*/
<template>
  <div>
    <public-title>关联门店
      <span class="text-link ml-auto" @click="$router.push({name:'GroupManage',query:{tab:queryCon.type}})" slot="right">返回列表</span>
    </public-title>
    <div class="bg-white load-area">
      <div class="d-center pt-4 mb-4">
        <span class="h4 text-blue mb-0 font-weight-bold ml-2">{{groupBasicInfo.group_name}}</span>
        <!-- <span class="text-muted ml-3">职位：<span class="text-warning">{{groupBasicInfo.position_name}}</span></span> -->
        <span class="text-muted ml-5">联系人：{{groupBasicInfo.truename}}</span>
        <span class="text-muted mr-4">{{groupBasicInfo.mobile}}</span>
        <span class="text-muted">旗下已收入子门店：<span class="text-link" @click="thoseShow">{{groupChildrenList.length}}家</span></span>
      </div>
      <transition name="fade">
        <div class="mt-3 mb-3" v-if="showChildren">
          <div class="text-right pr-5 h6"><a href="javascript:;" @click="showChildren=false"><i class="iconfont">&#xe840;</i>收起</a>
          </div>
          <ul class="d-center-between text-blue border-bottom border-top">
            <li class="w-40 pt-2 pb-2">门店名称</li>
            <li class="w-20 pt-2 pb-2">负责人</li>
            <li class="w-20 pt-2 pb-2">地址</li>
            <li class="w-20 pt-2 pb-2">认证状态</li>
          </ul>
          <ul class="d-center-between border-bottom" v-for="item in groupChildrenList" :key="item.title">
            <li class="w-40 pt-2 pb-2 text-left">{{item.title}}</li>
            <li class="w-20 pt-2 pb-2">
              <el-popover placement="right" trigger="hover">
                <div v-for="(v,ind) in item.user_list" :key="ind">
                  <i class="iconfont icon-weixin1 mr-1" :class="[v.wechat_openid ? 'text-success' : 'text-muted']"></i>
                  <span class="mr-2">{{v.truename}}</span><span class="mr-2">{{v.name}}</span>
                  <span class="mr-2">{{v.mobile}}</span>
                </div>
                <span slot="reference" class="text-link">{{item.user_list.length}}</span>
              </el-popover>
            </li>
            <li class="w-20 pt-2 pb-2">{{item.province_name}}-{{item.city_name}}</li>
            <li class="w-20 pt-2 pb-2">
              <span class="text-success" v-if="item.verify">已认证</span>
              <span class="text-danger" v-if="!item.verify">未认证</span>
            </li>
          </ul>
          <div v-if="groupChildrenList.length<=0" class="mt-4 h5">还没有添加任何子门店</div>
        </div>
      </transition>
      <el-input placeholder="子门店名称" class="w-50" v-model="nameCondition" @keyup.enter.native="searchChildren(1)" v-if="add">
        <el-button slot="append" icon="el-icon-search" @click="searchChildren(1)">搜索</el-button>
      </el-input>
      <el-button type="success" @click="addChildren" class="ml-2" v-show="total>0 && add">一键添加</el-button>
      <div class="mt-3" v-if="total>0">
        <div v-if="add">
          <p class="mb-2 text-left">共搜索到 <span class="ml-1 mr-1 text-danger">{{total}}</span>家门店</p>
          <div class="text-left">
            <span v-show="chooseChildren.length>0">已添加门店：</span>
            <el-tag class="mr-2 mb-2" v-for="tag in chooseChildren" :key="tag.id">
              {{tag.title}}
            </el-tag>
          </div>
        </div>
        <ul class="d-center-between border-bottom border-top mt-4 text-center">
          <li class="w-30 pt-2 pb-2">门店名称</li>
          <!-- <li class="w-20 pt-2 pb-2" v-if="edit && queryCon.type == 3">星级</li> -->
          <li class="w-20 pt-2 pb-2">地址</li>
          <li class="w-20 pt-2 pb-2">认证状态</li>
          <li class="w-10 pt-2 pb-2">负责人</li>
          <li class="w-10 pt-2 pb-2">操作</li>
        </ul>
        <ul class="d-center-between border-bottom text-center" v-for="item in searchResult" :key="item.id">
          <li class="w-30 pt-2 pb-2 text-left">
            <el-checkbox v-if="add" v-model="item.checked" :disabled="item.disabled" class="mr-2 breakword">{{item.title}}</el-checkbox>
            <div v-else>{{item.title}}</div>
          </li>
          <!-- <li class="w-20 pt-2 pb-2" v-if="edit && queryCon.type == 3">{{item.star | formatVar('HotelStar')}}</li> -->
          <li class="w-20 pt-2 pb-2">{{item.province_name+'-'}}{{item.city_name}}</li>
          <li class="w-20 pt-2 pb-2">
            <span class="text-success" v-if="item.verify">已认证</span>
            <span class="text-danger" v-if="!item.verify">未认证</span>
          </li>
          <li class="w-10 pt-2 pb-2">
            <div v-if="add">
              <el-popover placement="right" trigger="hover">
                <div v-for="(v,ind) in item.user_list" :key="ind">
                  <i class="iconfont icon-weixin1 mr-1" :class="[v.wechat_openid ? 'text-success' : 'text-muted']"></i>
                  <span class="mr-2">{{v.truename}}</span><span class="mr-2">{{v.name}}</span>
                  <span class="mr-2">{{v.mobile}}</span>
                </div>
                <span slot="reference" class="text-link">{{item.user_list.length}}</span>
              </el-popover>
            </div>
            <div v-else>
              <el-popover placement="right" trigger="hover" v-show="item.user_list.length > 1">
                <div v-for="(v,ind) in item.user_list" :key="ind">
                  <i class="iconfont icon-weixin1 mr-1" :class="[v.wechat_openid!=v.uid ? 'text-success' : 'text-muted']"></i>
                  <span class="mr-2">{{v.truename}}</span><span class="mr-2">{{v.name}}</span>
                  <!-- <span class="mr-2">{{v.mobile}}</span><span class="text-link" v-show="v.uid != queryCon.id" @click="$router.push({name: 'removeLeader',query: {id:v.uid,type:v.type,groupId:queryCon.id}})">设置负责人</span> -->
                </div>
                <span slot="reference" class="text-link">{{item.user_list.length}}</span>
              </el-popover>
              <el-button type="primary" size="small" v-show="item.user_list.length <= 1" @click="storeitem=item;showAdd=true">添加负责人</el-button>
            </div>
          </li>
          <li class="w-10 pt-2 pb-2">
            <div v-if="add" class="text-link" @click="StoreDetail(item.id)">查看</div>
            <div v-else class="text-link" @click="removeStore(item.id)">移除关联门店</div>
          </li>
        </ul>
        <el-dialog :visible.sync="showAdd" center title="新增负责人">
          <div class="p-3">
            <el-row class="mb-3">
              <el-col :span="12">门店名称：<span class="text-blue">{{storeitem.title}}</span></el-col>
              <el-col :span="12" class="pl-4">所属区域：{{storeitem.province_name}}-{{storeitem.city_name}}</el-col>
              <!-- <el-col :span="12" class="pl-4">
                <span v-if="queryCon.type == 3">酒店星级：{{storeitem.star | formatVar('HotelStar')}}</span>
                <span v-if="queryCon.type == 6">景点星级：{{storeitem.star | formatVar('scenicStarArr')}}</span>
              </el-col> -->
            </el-row>
            <!-- <el-row>
              
              <el-col :span="12" class="pl-4">详细地址：{{storeitem.address}}</el-col>
            </el-row> -->
            <left-text-border class="m-auto mt-5 w-70 narrow" leftText="负责人" v-model="leading"/>
            <left-text-border class="m-auto mt-3 w-70 narrow" leftText="手机号" v-model="mobile"/>
            <left-text-border class="m-auto mt-3 w-70 narrow" leftText="密码" v-model="oldpass" type="password" />
            <left-text-border class="m-auto mt-3 w-70 narrow" leftText="确认密码" v-model="newpass" type="password" />
            <div class="d-flex flex-wrap m-auto mt-3 w-70">
                <left-text leftText="职位"/><span>主账号</span>
            </div>
            <div class="d-flex flex-wrap m-auto mt-3 w-70">
                <left-text leftText="状态"/>
                <label>
                  <el-radio v-model="radio" label="1">正常</el-radio>
                  <el-radio v-model="radio" label="0">禁用</el-radio>
                </label>
            </div>
            <div class="d-center-space mt-5 text-center">
              <el-button class="mr-5" type="primary" size="small" @click="addLead">提交</el-button>
              <el-button size="small" @click="resetForm">重置</el-button>
            </div>
          </div>
        </el-dialog>
        <el-pagination background layout="prev, pager, next" class="mt-4" :total="total" :current-page=page
          :page-size="10" @current-change="v => this.changeList(v)" />
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapMutations,mapActions} from 'vuex'

  export default {
    data() {
      return {
        showChildren: false,             //显示已关联门店
        groupBasicInfo: {},               //集团基本信息
        groupChildrenList: [],            //已添加子门店数组
        nameCondition: '',                //搜索子门店名称
        searchResult: [],                 //搜索结果列表
        chooseChildren: [],               //已选门店
        total: 0,                         // 分页器记录总条数
        page: 1,                   // 当前的页数
        showAdd: false,
        storeitem: {},
        leading: '',
        mobile: '',
        oldpass: '',
        newpass: '',
        radio: '1'
      }
    },
    computed: {
      ...mapState(['userLoginMessage']),
      queryCon() {
        return this.$route.query
      },
      add () { return this.$route.query.status == 'add' },
      edit () { return this.$route.query.status == 'edit' },
      newChoose() {
        let list = this.searchResult.filter(v => v.checked);
        return list.map(v => v.id);
      }
    },
    created() {
      if (this.queryCon.page && this.edit) this.page = Number(this.queryCon.page)
      this.getGroupBasicInfo()
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getAdminDataLists']),
      StoreDetail(id){
        let routeUrl = this.$router.resolve({
          name: 'StoreDetail',
          query: {
            type:this.queryCon.type,
            id:id,
            none:1
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      thoseShow () {
        if(this.add){this.showChildren=!this.showChildren}
      },
      changeList (v) {
        this.page = v
        if (this.edit) this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.page}})
        if (this.add) this.searchChildren();
        else this.getList()
      },
      //集团下的子门店
      getList () {
        this.searchResult = this.groupChildrenList;
        this.total = this.store_count;
        // this.UPDATECURRENTSTORE({type: this.queryCon.type});
        // let data = {name: this.nameCondition,store_type: this.queryCon.type,group_id: this.queryCon.id,page:this.page}
        // this.getAdminDataLists({
        //     data,
        //     type: 'ticket',
        //     successFun: (res) => {
        //       console.log(res)

        //     }
        // });
      },
      /*获取集团账号基本信息*/
      async getGroupBasicInfo() {
        this.chooseChildren = [];
        let res = await this.$axios.post('/pc/Admin/GroupDetail',{
          group_id: this.queryCon.id,
        });
        if (res.code === '00000') {
          this.groupBasicInfo = res.data.info;
          this.groupChildrenList = res.data.store_list;
          this.store_count=res.data.store_count;
           if (!this.add) this.getList()
          for (let i = 0; i < this.groupChildrenList.length; i++) {
            this.chooseChildren.push({
              id: this.groupChildrenList[i].id,
              title: this.groupChildrenList[i].title
            });
          }
        }
      },
      /*搜索子门店*/
      async searchChildren(page) {
        if (page) this.page = page;
        if (!this.add) { this.getList(); return }
        let res = await this.$axios.post('/pc/Admin/GroupFindStore',{
          title: this.nameCondition,
          group_id: this.queryCon.id,
          page: this.page,
          num: 10
        });
        if (res.code === '00000' || res.code === '99999') {
          this.searchResult = res.data.list || [];
          this.total = res.data.count || 0;
        }
      },
      /*添加门店关联到集团账号*/
      addChildren() {
        if (!this.$GFUN.powerIsInArray([93])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (this.newChoose.length <= 0) {
          this._alert('您还没有选择任何门店',null,'error');
        } else {
          this._confirm('确定添加么？',async () => {
            // let ids = this.chooseChildren.map(v => v.id);
            let ids = this.newChoose;
            let res = await this.$axios.post('/pc/Admin/GroupAddStore',{
              group_id: this.queryCon.id,
              // store_type: this.queryCon.type,
              store_ids: ids,
              // group_name: this.groupBasicInfo.group_name
            });
            if (res.code === '00000') {
              this._alert('操作成功', () => {
                this.getGroupBasicInfo()
                this.searchChildren()
              });
            }
          })
        }
      },
      // 移除关联门店
      async removeStore (id) {
        this._confirm('确定移除门店嘛？',async () => {
          let res = await this.$axios.post('/pc/Admin/GroupRemoveStore',{
            store_id: id,
            group_id: this.queryCon.id,
          });
          if (res.code === '00000') {
            this._alert('移除成功',this.getGroupBasicInfo());
          }
        })
      },
      resetForm () {
        this.leading = ''; this.mobile = ''; this.oldpass = ''; this.newpass = ''; this.radio = '1'
      },
      /*表单验证*/
      validateForm () {
        if (!this.$GFUN.isName(this.leading)) return { code: false, msg: '请填写正确的负责人姓名' }
        //if (!this.$GFUN.isPhone(this.mobile)) return { code: false, msg: '手机号填写不正确' }
        if (!this.oldpass || !this.newpass) return { code: false, msg: '请输入密码' }
        if (this.oldpass !== this.newpass) return { code: false, msg: '两次密码不一致' }
        return { code: true, msg: '表单验证通过' }
      },
      //添加负责人
      async addLead () {
        let result = this.validateForm()
        if (result.code) {
          this._confirm('确定添加么？',async () => {
            let position_id = '1';
            switch (Number(this.queryCon.type)) {
              case 2: position_id='1';break;
              case 3: position_id='3';break;
              case 5: position_id='17';break;
              case 6: position_id='19';break;
            }
            let ids = [];ids.push(this.storeitem);
            let store_arr = ids.map(v => ({store_id: v.id, province: v.province, city: v.city, district:v.district}))
            let res = await this.$axios.post('/pc/Admin/GroupAddStoreUser',{
              truename: this.leading,group_id:this.queryCon.id,
              mobile: this.mobile,
              pwd: this.oldpass,pwd2: this.newpass,
              status: this.radio,
              // type: this.queryCon.type,group_name:this.queryCon.name,
              store_id:this.storeitem.id
            });
            if (res.code === '00000' || res.code === '99999') {
              this._alert('操作成功', () => {
                this.resetForm()
                this.showAdd=false;
                this.getGroupBasicInfo();
              });
            }
          })
        } else this.$message.warning(result.msg)
      }
    }
  }
</script>
